import { SuccessfulResponse } from './types'

export const isSuccessful = <ResultType>(
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types */
  response: any,
): response is SuccessfulResponse<ResultType> => {
  return 'success' in response && 'data' in response && !('errors' in response)
}
